import { Pipe, PipeTransform } from '@angular/core';
import { ReferenceData } from '../models/reference-data.model';
import { ReferenceDataService } from '../services/reference-data.service';

@Pipe({ name: 'localizeOptionList' })
export class LocalizeOptionListPipe implements PipeTransform {
  constructor(private referenceDataService: ReferenceDataService) {}

  transform(id: string): Array<ReferenceData> {
    return this.referenceDataService.getOptionListConfigItems(id);
  }
}
